export default {
	"billingItems": {
		"name": "billing item name",
		"type": "level",
		"billingItemInfo": "billing item information",
		"billingItemCodeTips": "please enter the billing item code (maximum 32 characters)",
		"billingItemNameTips": "please enter the name of the billing item (maximum 32 characters)",
		"addBillingItem": "add billing item",
		"trunk": "linehaul",
		"distribution": "home delivery",
		"storage": "warehouse",
		"appreciation": "add value service"
	},
	"billingRules": {
		"ruleName": "rule name",
		"remark": "rules description",
		"rule": "calculation rules",
		"billingRule": "billing rules",
		"ruleTips": "please enter the calculation rules (maximum 6000 characters)",
		"ruleTest": "you can test here",
		"invokeParam": "fill in the parameter values ​​required for the trial calculation (maximum 2000 words)",
		"startTest": "start testing",
		"getReturnResult": "click start test and return test results.",
		"addBillingRules": "add billing rules"
	},
	"billingShares": {
		"shareName": "allocation rule name",
		"rule": "allocation configuration",
		"shareNameTips": "please enter the name of the allocation rule (maximum 20 characters)",
		"ruleCodeTips": "please enter the rule code (maximum 32 characters)",
		"ruleTips": "please enter the allocation configuration (maximum 6000 characters)",
		"invokeParam": "fill in the parameter values ​​required for the trial calculation (maximum 500 characters)",
		"addShareRules": "add allocation rules"
	},
	"calculatorManage": {
		"name": "meter",
		"date": "date",
		"time": "time",
		"manualTrigger": "manual trigger",
		"calculatorInfo": "biller information",
		"nameTips": "please enter the name of the meter (maximum 32 characters)",
		"realTime": "real time",
		"everyday": "daily",
		"calculationTask": "computing task",
		"calculationTaskConfig": "configure computing task",
		"quoteTypeTips": "please select a contract type first",
		"addCalculator": "add meter",
		"number": "no",
		"spot": "point",
		"refreshTips": "the underlying data failed to load, please try pressing f5 to refresh the page and try again."
	},
	"contractManage": {
		"contractNoLike": "contract number/external contract number",
		"serviceProducts": "service product/project",
		"createDtInitData": "create a period",
		"startInitData": "effective period",
		"endInitData": "expiration period",
		"renew": "renew",
		"switch": "toggle",
		"dateChange": "adjust effective date",
		"quoteMaintain": "maintain rate card",
		"fileAdmin": "attachment management",
		"mainContractNo": "main contract id",
		"pleaseInputLightRatio": "please enter the volume/weight ratio (a number greater than 0 and less than 999)",
		"contractRenewal": "renew the contract",
		"contractSwitch": "contract switching",
		"splitData": "switch date",
		"contractFileAdmin": "contract attachment management",
		"addContract": "create a contract",
		"threeMonthsAgo": "three months before",
		"aMonthsAgo": "previous month",
		"aWeekAgo": "last week",
		"aWeekLater": "next week",
		"aMonthsLater": "next month",
		"threeMonthsLater": "last three months",
		"noProductInformation": "unrecognized product information.",
		"duplicateProductInformation": "duplicate product information",
		"nocontractData": "unrecognized contract data.",
		"contractCannotBeDeleted": "could not delete contract",
		"onlyNewCanBeDeleted": "only newly created contracts can be deleted.",
		"pleaseSelectDate": "please select an effective date and an expiry date.",
		"errDateTips": "the effective date cannot be later than the expiry date.",
		"confirmRenew": "are you sure you want to renew?",
		"pleaseSelectSwitchingDate": "please select a switching date",
		"confirmSwitch": "are you sure you want to switch?",
		"sequenceNoTips": "please enter serial number",
		"curSequenceNo": "the current serial number is",
		"inputTips": "please enter an integer no greater than 7 digits."
	},
	"dataResource": {
		"sourceFeture": "data source properties",
		"dataResourceInfo": "data source information",
		"dataResourceTips": "please enter the data source name (maximum 20 characters)",
		"sourceType": "data source type",
		"sourceFetureTips": "please select a data source property",
		"sourceContextTips": "please enter the configuration (up to 4000 characters)",
		"testTips": "you can test here",
		"inputTips": "fill in the parameter value (maximum 500 characters)",
		"addDataResource": "add data source"
	},
	"motherTemplate": {
		"motherboardName": "template name",
		"downloadMotherboard": "download the template",
		"upload": "upload",
		"motherboardInfo": "template information",
		"quoteMotherboardName": "rate card template name",
		"addMotherboard": "add a template"
	},
	"quoteMaintain": {
		"quotationTemplate": "rate card template",
		"content": "content",
		"importQuotation": "import rate card",
		"exportQuotation": "export rate card",
		"clearQuotation": "clear quote",
		"pleaseClick": "please click the quote template above",
		"importQuotationSuccess": "rate card imported successfully",
		"revokeOperation": "are you sure to undo the operation?",
		"changeNew": "are you sure to change the contract to \"new\" status?",
		"noTemplateNotQuotation": "the quotation cannot be imported without the quotation template. please upload the template and try again.",
		"contractAdmin": "contract management",
		"noserviceProduct": "you haven't set up service product!"
	},
	"serviceitems": {
		"choseNode": "select time",
		"serviceType": "service type",
		"serviceName": "service name",
		"serviceNameTips": "please enter the service name (maximum 32 characters)",
		"provider": "server",
		"synmode": "business synchronization",
		"codeTips": "please enter a code (up to 32 characters)",
		"custom": "business customization",
		"unit": "quotation unit",
		"unitTips": "please enter the quotation unit (maximum 32 digits)",
		"addService": "new service item",
		"inputSequenceNo": "please enter serial number",
		"curSequenceNo": "the current serial number is",
		"inputErrorMessage": "please enter an integer no more than 7 digits"
	},
	"account": {
		"companyName": "company name",
		"businessLicense": "business license no",
		"nature": "nature",
		"parentCompany": "superior enterprise",
		"shortName": "abbreviation",
		"address": "mailing address",
		"contact": "Please enter contact name",
		"pleaseSelectTheKeyContactPerson": "Please select the Key Contact Person",
		"pleaseSelectTheKeyContactName": "Please select the Key Contact Name",
		"addContact": "add contacts",
		"mobile": "cell phone",
		"email": "email",
		"duty": "job title",
		"uploadLogo": "upload avatar"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/account/account.js